


































import { Vue, Component, Prop } from "vue-property-decorator";
import { UserProfile } from "../../../api/models/UserProfile";
import UserIcon from './UserBlockIcon/UserBlockIcon.vue';
import { Location } from "vue-router";

@Component({
    components: { UserIcon }
})
export default class UserBlock extends Vue {
    @Prop({default: null}) speaker: UserProfile|null;
    @Prop({default: 32}) userIconSize: number;

    @Prop({default: false}) hideInfo: boolean;
    @Prop({ default: true }) needOpenChat: boolean;
    @Prop({default: null}) amount: number|null;
    @Prop({ default: null }) link: Location

    get isMore() {
        return this.amount && this.amount > 0;
    }

    get moreIconSizeStyles() {
        return {'height': `${this.userIconSize}px`, borderRadius: `${this.userIconSize}px`}
    }

    get fullName(): string {
        return this.speaker ? [this.speaker.firstName, this.speaker.lastName].filter(item => item).join(' ') : '';
    }

    get company(): string {
        return this.speaker?.company || '';
    }

    get profilePicture(): string {
        return (this.speaker?.profilePhotoLink(this.backend) as string);
    }

    get firstEntranceStatus() {
        if (this.speaker) {
            return this.speaker.firstEntranceStatus ||  false;
        }
        return false;
    }

    get initials(): string {
        return (this.speaker?.initials as string);
    }

    get profileColor(): string {
        return (this.speaker?.profileColor as string);
    }

    get job() {
        return this.speaker?.job;
    }

    get backend() {
        return this.$store.state.session.backend;
    }

    toUser(e: MouseEvent) {
        if(this.needOpenChat) {
            e.preventDefault();
            e.stopPropagation();
            this.$emit('click', this.speaker?.userId);
        }
    }
}
